var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoOutlinedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 17.0833C13.9119 17.0833 17.0832 13.912 17.0832 9.99996C17.0832 6.08794 13.9119 2.91663 9.99984 2.91663C6.08782 2.91663 2.9165 6.08794 2.9165 9.99996C2.9165 13.912 6.08782 17.0833 9.99984 17.0833ZM9.99984 18.3333C14.6022 18.3333 18.3332 14.6023 18.3332 9.99996C18.3332 5.39759 14.6022 1.66663 9.99984 1.66663C5.39746 1.66663 1.6665 5.39759 1.6665 9.99996C1.6665 14.6023 5.39746 18.3333 9.99984 18.3333ZM8.1818 7.72716H10.9091V14.0908H11.8182V14.9999H8.1818V14.0908H9.0909V8.63626H8.1818V7.72716ZM9.99951 6.81815C10.5016 6.81815 10.9086 6.41114 10.9086 5.90906C10.9086 5.40698 10.5016 4.99996 9.99951 4.99996C9.49743 4.99996 9.09041 5.40698 9.09041 5.90906C9.09041 6.41114 9.49743 6.81815 9.99951 6.81815Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutlinedCircle);
export default __webpack_public_path__ + "static/media/info-outlined-circle.81cbeee0810246434742f8c3e9201859.svg";
export { ForwardRef as ReactComponent };